import ParkPassAPI from "../parkpassAxiosConfig";

/**
 * Get all reclamations (admin)
 * @param {Object} params - Query parameters (status, etc.)
 * @returns {Promise} - Axios response
 */
export const getReclamations = async (params = {}) => {
  const response = await ParkPassAPI.get("/v1/reclamations/admin", { params });
  return response;
};

/**
 * Get a specific reclamation by ID (admin)
 * @param {number} id - Reclamation ID
 * @returns {Promise} - Axios response
 */
export const getReclamationById = async (id) => {
  const response = await ParkPassAPI.get(`/v1/reclamations/admin/${id}`);
  return response;
};

/**
 * Update reclamation status (admin)
 * @param {number} id - Reclamation ID
 * @param {Object} data - Status update data
 * @returns {Promise} - Axios response
 */
export const updateReclamationStatus = async (id, data) => {
  const response = await ParkPassAPI.patch(`/v1/reclamations/admin/${id}/status`, data);
  return response;
};

/**
 * Reply to a reclamation (admin). Stores a citizen-visible reply, optionally
 * updates the status, and notifies the citizen.
 * @param {number} id - Reclamation ID
 * @param {Object} data - { admin_reply: string, status?: string }
 * @returns {Promise} - Axios response
 */
export const replyToReclamation = async (id, data) => {
  const response = await ParkPassAPI.patch(`/v1/reclamations/admin/${id}/reply`, data);
  return response;
};
